module.exports = __webpack_public_path__ + "img/jersey_thumbnail.8c4b3958.jpg";